<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Cloud Printer Settings Page
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Printer Settings",
      items: [],
      loading: false,
      userinfo: null,
      setting: {
        status: false,
        authcode: "",
        deviceid: "",
        version: "",
        language: "zh-cn",
        autoprint: false,
        scanpaycode: false,
      },
      template: {
        tempid: "ushengyun",
        text: "",
      },
      submitLoading: false,
      languageOptions: [
        { label: "简体中文", value: "zh-cn" },
        { label: "繁體中文", value: "zh-hk" },
        { label: "English", value: "en" },
        { label: "日本語", value: "ja-jp" },
      ],
      templateOptions: [
        { label: "优声云", value: "ushengyun" },
        { label: "易联云", value: "yilianyun" },
        { label: "自定义", value: "custom" },
      ],
    };
  },
  mounted() {
    this.title = this.$t("menuitems.clouds.printer.text");
    this.items = [
      {
        text: this.$t("menuitems.clouds.text"),
        href: "/",
      },
      {
        text: this.$t("menuitems.clouds.printer.text"),
        active: true,
      },
    ];

    try {
      this.userinfo = JSON.parse(localStorage.getItem("user"));
      if (!this.userinfo) {
        this.$message.error(this.$t("global.errors.loginrequired"));
        this.$router.push({ name: "login" });
        return;
      }
    } catch (error) {
      console.error("解析用户信息失败:", error);
      this.$message.error(this.$t("global.errors.loginrequired"));
      this.$router.push({ name: "login" });
      return;
    }

    this.getprintersetting();
  },
  computed: {
    formRules() {
      return {
        authcode: [
          { required: true, message: this.$t("clouds.printer.serial_required") || "请输入序列号", trigger: "blur" }
        ],
        deviceid: [
          { required: true, message: this.$t("clouds.printer.deviceid_required") || "请输入设备ID", trigger: "blur" }
        ],
      };
    },
  },
  methods: {
    getprintersetting() {
      this.loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "getprintersetting"
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.loading = false;
          if (response.data.status === 200) {
            this.setting = {
              status: response.data.setting?.status || false,
              authcode: response.data.setting?.authcode || "",
              deviceid: response.data.setting?.deviceid || "",
              version: response.data.setting?.version || "",
              language: response.data.setting?.language || "zh-cn",
              autoprint: response.data.setting?.autoprint || false,
              scanpaycode: response.data.setting?.scanpaycode || false,
            };
            if (response.data.template) {
              this.template = {
                tempid: response.data.template.tempid || "ushengyun",
                text: response.data.template.text || "",
              };
            }
          } else if (response.data.status !== 404 && response.data.status !== "404") {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.loaddata"));
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("获取打印机设置失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }

        this.submitLoading = true;
        this.$axios
          .post(
            this.apiuri,
            {
              action: "saveprintersetting",
              data: this.setting,
            },
            {
              headers: { Openid: this.userinfo.openid },
            }
          )
          .then((response) => {
            this.submitLoading = false;
            if (response.data.status === 200) {
              this.$message({
                message: response.data.msg || this.$t("global.success"),
                type: "success",
              });
              this.getprintersetting();
            } else {
              this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.operation"));
            }
          })
          .catch((error) => {
            this.submitLoading = false;
            console.error("保存打印机设置失败:", error);
            this.$message.error(this.$t("global.errors.network"));
          });
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.getprintersetting();
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="row">
          <!-- 打印机设置 -->
          <div class="col-lg-6 col-md-12 mb-4">
            <el-card class="box-card" v-loading="loading">
              <div slot="header" class="clearfix">
                <span>
                  <i class="el-icon-setting"></i>
                  {{ $t("menuitems.clouds.printer.setting.text") }}
                </span>
              </div>
              <div>
                <el-form 
                  ref="form" 
                  :model="setting" 
                  :rules="formRules"
                  label-width="120px"
                  label-position="left"
                >
                  <el-form-item :label="$t('clouds.printer.switch')">
                    <el-switch 
                      v-model="setting.status"
                      :active-text="$t('global.text.yes')"
                      :inactive-text="$t('global.text.no')"
                    ></el-switch>
                    <div class="form-item-tip">
                      <small class="text-muted">{{ $t("clouds.printer.switch_tip") || "开启或关闭打印机服务" }}</small>
                    </div>
                  </el-form-item>
                  
                  <el-form-item :label="$t('clouds.printer.serial')" prop="authcode">
                    <el-input 
                      v-model="setting.authcode"
                      :placeholder="$t('clouds.printer.serial_placeholder') || '请输入打印机序列号'"
                      clearable
                    ></el-input>
                  </el-form-item>
                  
                  <el-form-item :label="$t('clouds.printer.deviceid')" prop="deviceid">
                    <el-input 
                      v-model="setting.deviceid"
                      :placeholder="$t('clouds.printer.deviceid_placeholder') || '请输入设备ID'"
                      clearable
                    ></el-input>
                  </el-form-item>
                  
                  <el-form-item :label="$t('clouds.printer.version')">
                    <el-input 
                      :value="setting.version || '-'"
                      disabled
                      style="width: 100%"
                    ></el-input>
                    <div class="form-item-tip" v-if="setting.version">
                      <small class="text-muted">{{ $t("clouds.printer.version_tip") || "当前打印机固件版本" }}</small>
                    </div>
                  </el-form-item>
                  
                  <el-form-item :label="$t('clouds.printer.language')">
                    <el-select 
                      v-model="setting.language" 
                      :placeholder="$t('clouds.printer.select_language')"
                      style="width: 100%"
                      filterable
                    >
                      <el-option 
                        v-for="option in languageOptions" 
                        :key="option.value"
                        :label="option.label" 
                        :value="option.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  
                  <el-form-item :label="$t('clouds.printer.autoswitch')">
                    <el-switch 
                      v-model="setting.autoprint"
                      :disabled="!setting.version || (!setting.version.includes('K4') && !setting.version.includes('K8'))"
                      :active-text="$t('global.text.yes')"
                      :inactive-text="$t('global.text.no')"
                    ></el-switch>
                    <div class="form-item-tip" v-if="!setting.version || (!setting.version.includes('K4') && !setting.version.includes('K8'))">
                      <small class="text-muted">{{ $t("clouds.printer.autoswitch_tip") || "此功能仅支持K4和K8型号" }}</small>
                    </div>
                  </el-form-item>
                  
                  <el-form-item :label="$t('clouds.printer.scanpaycode')">
                    <el-switch 
                      v-model="setting.scanpaycode"
                      :disabled="!setting.version || !setting.version.includes('K8')"
                      :active-text="$t('global.text.yes')"
                      :inactive-text="$t('global.text.no')"
                    ></el-switch>
                    <div class="form-item-tip" v-if="!setting.version || !setting.version.includes('K8')">
                      <small class="text-muted">{{ $t("clouds.printer.scanpaycode_tip") || "此功能仅支持K8型号" }}</small>
                    </div>
                  </el-form-item>
                  
                  <el-form-item>
                    <el-button 
                      type="primary" 
                      @click="onSubmit"
                      :loading="submitLoading"
                      icon="el-icon-check"
                    >{{ $t("menuitems.clouds.printer.save") }}</el-button>
                    <el-button 
                      @click="resetForm"
                      icon="el-icon-refresh"
                    >{{ $t("global.button.cancel") }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-card>
          </div>

          <!-- 打印模板设置 -->
          <div class="col-lg-6 col-md-12 mb-4">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>
                  <i class="el-icon-document"></i>
                  {{ $t("menuitems.clouds.printer.template.text") }}
                </span>
              </div>
              <div>
                <el-form 
                  ref="templateForm" 
                  :model="template" 
                  label-width="120px"
                  label-position="left"
                >
                  <el-form-item :label="$t('clouds.printer.template')">
                    <el-select 
                      v-model="template.tempid" 
                      :placeholder="$t('clouds.printer.select_template')"
                      style="width: 100%"
                      filterable
                    >
                      <el-option 
                        v-for="option in templateOptions" 
                        :key="option.value"
                        :label="option.label" 
                        :value="option.value"
                      ></el-option>
                    </el-select>
                    <div class="form-item-tip">
                      <small class="text-muted">{{ $t("clouds.printer.template_tip") || "选择打印模板类型" }}</small>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      type="primary"
                      plain
                      icon="el-icon-edit"
                      @click="$router.push({ name: 'CloudPrinterTemplate' })"
                    >{{ $t("clouds.printer.editor.open") }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.form-item-tip {
  margin-top: 5px;
}

.box-card {
  margin-bottom: 20px;
}

.clearfix {
  font-weight: 500;
}

.clearfix i {
  margin-right: 5px;
}
</style>